// extracted by mini-css-extract-plugin
module.exports = {"errorPage":"error_errorPage__1sLI9","icon":"error_icon__15Wh9","message":"error_message__1LfFD","btn":"error_btn__21OJN"};